import React from "react"

import { GroupFilters } from "client/store"
import { SearchBar } from "client/components"

interface SearchGroup {
    id: string
    leftOffset?: boolean
    rightOffset?: boolean
    filters: GroupFilters
    onFilter: (filters: GroupFilters) => void
}

const GroupSearch = ({
    id,
    leftOffset = false,
    rightOffset = false,
    filters,
    onFilter,
}: SearchGroup) => (
    <SearchBar
        id={id}
        filters={filters}
        leftOffset={leftOffset}
        rightOffset={rightOffset}
        onFilter={onFilter}
    />
)
export default GroupSearch
